"use client"

import React from "react"
import Link from "next/link"
import * as classes from "./header.module.scss"
import BookingModal from "@/components/Modal/bookingModal"
import SalesForceBookingModal from "@/components/Modal/SalesForceBookingModal"

const Header = ({ siteInfo, theme, bookMeetingData }) => {
  const { website, contact_us, logo } = siteInfo
  const [modalIsOpen, setIsOpen] = React.useState(false)

  function openModal() {
    setIsOpen(true)
  }

  function closeModal() {
    setIsOpen(false)
  }

  return (
    <>
      <div
        className={classes[`${true ? "headerWrapperScroll" : "headerWrapper"}`]}
      >
        <div className={classes["headerSubWrapper"]}>
          <a className={classes["homeIcon"]} href={website} target="_blank">
            <img src={logo} alt="home logo" />
          </a>

          <div className={classes["navbarRightSection"]}>
            {bookMeetingData.calendlyLink ? (
              <a
                className={classes["contactIcon"]}
                target="_blank"
                rel="noreferrer"
              >
                <button
                  onClick={openModal}
                  style={{ backgroundColor: theme.primaryColor }}
                >
                  Book a meeting
                </button>
              </a>
            ) : (
              <a
                className={classes["contactIcon"]}
                href={contact_us}
                target="_blank"
                rel="noreferrer"
              >
                <button style={{ backgroundColor: theme.primaryColor }}>
                  Contact Us
                </button>
              </a>
            )}
            <SalesForceBookingModal
              bookMeetingData={bookMeetingData}
              modalIsOpen={modalIsOpen}
              openModal={openModal}
              closeModal={closeModal}
            />
            <Link className={classes["contactIcon"]} href={`/`} target="_blank">
              <button style={{ backgroundColor: "#efeeef", color: "black" }}>
                See All Stories
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header
